import React from 'react';

function Pcs () {
    return (
        <div>
            <p>Paper CS</p>    
            <div class="row">
                         
                        <div className='col'>
                            <ul className='left__side__list'>
                                <li>
                                   <a href='PYear2' > <button className='left__side__list upload__items diagonal-hoverrr'> <div className='contenttt'> <i className='fas fa-edit fa'></i> <br/> 2nd Year </div> </button> </a>
                                </li>
                            </ul>
                        </div>

                        <div className='col'>
                            <ul className='left__side__list'>
                                <li>
                                   <a href='https://drive.google.com/drive/folders/1HT1pBDtPFatd9DJ-TrGxI7bCv_iRD-fu' > <button className='left__side__list upload__items diagonal-hoverrr'> <div className='contenttt'> <i className='fas fa-edit fa'></i> <br/> 2019 - 2020 </div> </button> </a>
                                </li>
                            </ul>
                        </div>

                        <div className='col'>
                            <ul className='left__side__list'>
                                <li>
                                   <a href='https://drive.google.com/drive/folders/1a1SwAvcgscctgPKwM2rNP9wiTEBw8WHl' > <button className='left__side__list upload__items diagonal-hoverrr'> <div className='contenttt'> <i className='fas fa-edit fa'></i> <br/> 2021 - 2022 </div> </button> </a>
                                </li>
                            </ul>
                        </div>

                        <div className='col'>
                            <ul className='left__side__list'>
                                <li>
                                   <a href='https://drive.google.com/drive/folders/1E3SPOVlPoCf9Whctp5EjNddD8xktoooL' > <button className='left__side__list upload__items diagonal-hoverrr'> <div className='contenttt'> <i className='fas fa-edit fa'></i> <br/> 2022 - 2023 </div> </button> </a>
                                </li>
                            </ul>
                        </div>
                        
                    </div>
        </div>
    );
}

export default Pcs;
